type HasStartDate = {
    startDate: string | Date;
};

export function sortedData<T extends HasStartDate>(items: T[]): T[] {
    return [...items].sort(
        (a, b) =>
            new Date(b.startDate).getTime() - new Date(a.startDate).getTime(),
    );
}
